import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    OnChanges,
    OnDestroy,
    Output
} from "@angular/core";
import {MenuModel} from "../menu.model";
import {OrderModel} from "../../order/order.model";
import {ButtonProminence, ButtonTier} from "../../buttons/button/button";
import {FedeltaImageData} from "@fedelta-pos/data-client";
import {Subscription} from "rxjs";
import {OrderEvents} from "../../order/order-events";
import {PromoModel} from "../../promo/promo.model";
import {MenuEvents, MenuItemSelection} from "../menu-events";
import {PromoEvents} from "../../promo/promo-events";
import {MenuCategoryData, MenuItemData} from "../menu-entity.model";
import {AnalyticsService} from "../../orchestration/analytics.service";

@Component({
    selector: "woa-menu-item-panel",
    templateUrl: "./menu-item-panel.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuItemPanelComponent implements OnChanges, OnDestroy {
    @Input() category: MenuCategoryData;
    @Input() menuItem: MenuItemData;
    @Input() useOrderAction: boolean = false;
    @Input() @HostBinding("class.tile") tile: boolean = false;
    @Input() showCategoryPath: boolean = false;
    @Input() showDetails: boolean = true;
    @Input() fromSearch: boolean = false;

    @Output() onSelectItem: EventEmitter<void> = new EventEmitter();

    ButtonTier = ButtonTier;
    ButtonProminence = ButtonProminence;

    public image: FedeltaImageData;
    public featureTag: string;

    private subscriptions: Subscription = new Subscription();

    constructor(public menuModel: MenuModel,
                public promoModel: PromoModel,
                private changeDetectorRef: ChangeDetectorRef,
                private analyticsService: AnalyticsService,
                public orderModel: OrderModel) {
        this.subscriptions.add(MenuEvents.menuItemInitialised$.subscribe(async () => this.changeDetectorRef.detectChanges()));
        this.subscriptions.add(OrderEvents.orderChanged$.subscribe(() => this.changeDetectorRef.detectChanges()));
        this.subscriptions.add(PromoEvents.promotedSellablesRefreshed$.subscribe(() => {
            this.refresh();
            this.changeDetectorRef.detectChanges();
        }));
    }

    ngOnChanges(): void {
        this.refresh();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    refresh(): void {
        if (this.menuItem) {
            this.image = this.menuModel.getItemImage(this.category, this.menuItem, undefined, true);
            this.featureTag = this.promoModel.getPromotedFeatureTag(this.category, this.menuItem);
        }
    }

    @HostListener("click", ["$event"])
    selectItem(event: MouseEvent): void {
        event.stopPropagation();

        if (this.category.pairingsCategory) {
            // noinspection JSIgnoredPromiseFromCall
            this.analyticsService.trackPairingsShown();
            // noinspection JSIgnoredPromiseFromCall
            this.analyticsService.trackPairingSelected();
        } else if (this.fromSearch) {
            // noinspection JSIgnoredPromiseFromCall
            this.analyticsService.trackSearchItemSelected();
        }

        OrderEvents.requestOrderItem$.next(new MenuItemSelection(this.menuItem, this.category));
    }

    selectCategory(event: MouseEvent): void {
        event.stopPropagation();
        this.menuModel.selectCategory(this.category, false, event);
    }

    get showUnavailable(): boolean {
        return this.menuModel.itemOutOfStock(this.menuItem) || this.orderModel.menuItemAtLimit(this.menuItem, this.menuItem.sellable.minWebOrderQty);
    }

    get showOutOfStock(): boolean {
        return this.menuModel.itemOutOfStock(this.menuItem);
    }

    get showAtLimit(): boolean {
        return !this.menuModel.itemOutOfStock(this.menuItem) && this.orderModel.menuItemAtLimit(this.menuItem, this.menuItem.sellable.minWebOrderQty);
    }

    get showOrderAction(): boolean {
        return this.useOrderAction && !this.menuModel.itemOutOfStock(this.menuItem) && !this.orderModel.menuItemAtLimit(this.menuItem, this.menuItem.sellable.minWebOrderQty);
    }

    get canShowDetails(): boolean {
        return this.menuItem && this.showDetails && this.menuModel.isItemInitialised(this.menuItem);
    }
}



// WEBPACK FOOTER //
// ./src/app/menu/menu-item-panel/menu-item-panel.component.ts